export const files = {
  title: 'Files',
  searchByName: 'Szukaj po nazwie',
  delete: 'Delete model',
  deleteDisabled:
    'Cannot delete the file because it is used in one of the configurations',
  preview: 'Model preview',
  previewClose: 'Close preview',
  correctlyUploaded: 'Created successfully?',
  status: 'Status',
  statuses: {
    success: 'Correct',
    error: 'Incorrect',
    pending: 'In progress',
  },
  deleteSuccess: 'Model deleted successfully',
  label: 'Name',
  code: 'Code',
  dimensions: 'Model dimensions',
  dimensionX: 'Dimension X',
  dimensionY: 'Dimension Y',
  dimensionZ: 'Dimension Z',
  noFileFound: 'Nie znaleziono pliku z tym id',
  loadingFile: 'Loading file',
  detailsTitle: 'File details',
  tabs: {
    general: 'File data',
    dependence: 'Zależności',
    tree: 'Structure',
  },
  notifications: {
    update: 'Changes have been saved',
  },
  noResults: 'None',
  infoButton: 'File information',
  noDimensions: 'No dimensions',
}
